// extracted by mini-css-extract-plugin
export var layoutContainer = "_42-0";
export var layoutContainerOpen = "_42-3";
export var mainContent = "_42-1";
export var panelLarge = "_42-6";
export var panelMedium = "_42-5";
export var panelSmall = "_42-4";
export var slidePanel = "_42-2";